import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from '@/app/providers';
import { OverlayProvider } from '@platform/ui';
import { ThemeProvider } from '@/shared/theme';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

/**
 * MSW Mock Service Worker 활성화
 * - VITE_USE_MOCK=true 일 때만 동작
 * - 동적 import로 production 번들에서 제외
 */
async function enableMocking() {
  if (import.meta.env.VITE_USE_MOCK !== 'true') {
    return;
  }

  const { worker } = await import('@/mocks/browser');

  return worker.start({
    onUnhandledRequest: 'warn',
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
  });
}

// ─── App Render ────────────────────────
enableMocking().then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <ThemeProvider>
        <AppProvider>
          <OverlayProvider>
            <App />
          </OverlayProvider>
        </AppProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
